import {Box,Tooltip, useTheme} from "@mui/material";
import {deleteEntity, searchEntities} from './ProfilesReducer';
import React, {useCallback, useEffect, useState} from "react";
import {RootState} from "../../../Config/Store";
import {useAppDispatch, useAppSelector} from "../../../Config/Hooks";
import {useNavigate} from "react-router-dom";
import {useSnackbar} from "notistack";
import ConfirmDialog from "../../../Shared/Components/ConfirmDialog";
import {ACard, ADataGrid, ADataGridColumn, ADataGridFilter, PagedSearchParams} from "@atiautomacao/ati-ui-library";
import {searchEntitiesData} from "./AuthorityReducer";
import {clearCountryMessages} from "../Country/CountryReducer";
import {extractFiltersFromColumns} from "../../../Utils/DataUitils";
import {SystemRoutes} from "../../../Utils/RouteUtils";
import {
    AccountCircleOutlined,
    DeleteOutlined,
    EditOutlined,
    MoreHorizOutlined
} from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { hasPermission } from "../../../Shared/Auth/AuthenticationUtil";
import { AUTHORITIES } from "../../../Config/Constants";
import {HeaderMenu} from "../HeaderMenu";
import ActionsMenu, {ActionMenuItem} from "../../../Shared/Components/ActionsMenu";
import UserAssociationPanel from "./components/UserAssociationPanel";
import {QueryClientProvider} from "react-query";
import {sharedQueryClient} from "../../../queryClient";



const columns = [
    {
        name: 'id',
        label: 'ID',
        align: 'left',
        minWidth: 100,
        visibility: false,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
    {
        name: 'name',
        label: 'Nome',
        align: 'left',
        minWidth: 100,
        visibility: true,
        breakpoints: {
            xs: true,
            sm: true,
            md: true,
            lg: true,
            xl: true
        }
    },
] as ADataGridColumn [];


export type ActionConfig = {
    actionName: string;
    disabled: boolean;
};

export interface RowProfile {
    id: number;
    name: string;
    actionsConfig?: Array<ActionConfig>
}

export function ProfilesSettingsHomePage(){
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [authorityGroupId, setAuthorityGroupId] = useState<any>(null);
    const [openDialog, setOpenDialog] = useState(false);

    const account = useAppSelector(state => state.authentication.account);
    const isAuthorizedToSaveProfile = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.SAVE_PROFILE
    ]);
    const isAuthorizedToDeleteProfile = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.DELETE_PROFILE
    ]);
    const isAuthorizedToViewUsers = hasPermission(account?.authoritySet, [
        AUTHORITIES.SYSADMIN, AUTHORITIES.USER_AUTHORITY_GROUP_MANAGER, AUTHORITIES.VIEW_USER_AUTHORITIES_GROUP
    ])
    const isLoading = useAppSelector((state : RootState) => state.profile.loading);
    const errorMessage = useAppSelector((state : RootState) => state.profile.errorMessage);
    const successMessage = useAppSelector((state : RootState) => state.profile.successMessage);
    const entities = useAppSelector((state : RootState) => state.profile.entities);
    const totalOfRecords = useAppSelector((state : RootState) => state.profile.totalOfRecords);
    const [pagedSearchParams, setPagedSearchParams] = useState(new PagedSearchParams(extractFiltersFromColumns(columns), 0, 100));

    const [rows, setRows] = useState<Array<RowProfile>>([]);
    const [menuPos, setMenuPos] = useState<{ top: number; left: number } | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>(null);
    const [selectedProfileForUsers, setSelectedProfileForUsers] = useState<any>(null);
    const [openUserAssociationPanel, setOpenUserAssociationPanel] = useState(false);

    const lastMousePosRef = React.useRef({ x: 0, y: 0 });


    useEffect(() => {
        let newRows = entities.map(et => {return {id: et.id, name: et.name, actionsConfig: [
                {actionName: "edit", disabled: !isAuthorizedToSaveProfile},
                {actionName: "delete", disabled: !isAuthorizedToDeleteProfile},
            ]}});
            setRows(newRows)
        }, [entities]);


    const handleEditProfile = useCallback((data: any) => {
        navigate(SystemRoutes.SETTINGS_PROFILE_FORM, {state: {id: data.id}});
    },[navigate]);

    const deleteItemAction = useCallback((data: any) => {
        console.log("data: ", data)
        setAuthorityGroupId(data.id);
        setOpenDialog(true);
    },[]);

    const toggleDialog = () => {
        setOpenDialog(!openDialog);
    }

    const confirmDialog = async () => {
        try {
            await dispatch(deleteEntity(authorityGroupId)).unwrap();

            await dispatch(searchEntities(pagedSearchParams));

            enqueueSnackbar("Perfil deletado com sucesso!", {
                variant: 'success',
            });
        } catch (error) {
            enqueueSnackbar("O Perfil não pode ser deletado porque já está em uso.", {
                variant: 'error',
            });
        } finally {
            toggleDialog();
        }
    };

    const closeDialog = () => {
        //TODO
        // @ts-ignore
        setAuthorityGroupId({});
        toggleDialog();
    }

    const handleOnFiltersChange = useCallback((dataGridFilters: Array<ADataGridFilter>, page: number, pageSize: number) => {
        let newPageParams :PagedSearchParams = new PagedSearchParams(dataGridFilters, page, pageSize);
        setPagedSearchParams(
            newPageParams
        );
    },[]);

    const handleOnRowSelect = useCallback((rows : any) => {
    },[]);

    useEffect(() => {

        dispatch(searchEntitiesData(pagedSearchParams));
        if (!isLoading) {
            dispatch(searchEntities(pagedSearchParams));

        }
    },[dispatch, pagedSearchParams]);

    // On updateSuccess change
    useEffect(() => {
        if (successMessage) {
            enqueueSnackbar(successMessage, {
                variant: 'success',
            });
            dispatch(clearCountryMessages());
        }
        if(errorMessage) {
            enqueueSnackbar(errorMessage, {
                variant: 'error',
            });
            dispatch(clearCountryMessages());
        }
    }, [errorMessage, successMessage]);

    const handleMouseMove = (e: React.MouseEvent) => {
        lastMousePosRef.current = { x: e.clientX, y: e.clientY };
    };

    const handleActionsMenu = (row: any) => {
        setSelectedRow(row);
        setMenuPos({ left: lastMousePosRef.current.x, top: lastMousePosRef.current.y });
    };

    const handleCloseActionsMenu = () => {
        setMenuPos(null);
        setSelectedRow(null);
    };

    const handleOpenUserAssociation = useCallback((row: any) => {
        setSelectedProfileForUsers(row);
        setOpenUserAssociationPanel(true);
    }, []);


    const getActionMenuItems = (): ActionMenuItem[] => {
        if (!selectedRow) return [];

        return [
            {
                id: "edit",
                label: "Editar informações",
                icon: <EditOutlined fontSize="small" />,
                onClick: () => handleEditProfile(selectedRow),
                disabled: !isAuthorizedToSaveProfile
            },
            {
                id: "associateUsers",
                label: "Associar usuários",
                icon: <AccountCircleOutlined fontSize="small" />,
                onClick: () => handleOpenUserAssociation(selectedRow),
                disabled: !isAuthorizedToViewUsers
            },
            {
                id: "delete",
                label: "Excluir",
                icon: <DeleteOutlined fontSize="small" />,
                onClick: () => deleteItemAction(selectedRow),
                danger: true,
                dividerBefore: true,
                disabled: !isAuthorizedToDeleteProfile
            },
        ];
    };

    return (
        <>
            <HeaderMenu systemRoutes={SystemRoutes.SETTINGS_PROFILE_FORM} disableSave={!isAuthorizedToSaveProfile}/>
            <Box onMouseMove={handleMouseMove}>
                <ACard>
                    <ADataGrid
                        ariaLabel={"settings-profiles-grid"}
                        hideFilters={false}
                        hideSelection={false}
                        columns={columns}
                        rows={rows}
                        loading={false}
                        totalOfRecords={totalOfRecords}
                        page={pagedSearchParams.page}
                        rowsPerPage={pagedSearchParams.size}
                        onFiltersChange={handleOnFiltersChange}
                        onRowSelect={handleOnRowSelect}
                        actions={
                            <>
                                <span></span>
                                <IconButton
                                    name="actions"
                                    size={"small"}
                                    aria-label="Ações"
                                    onClick={(row: any) => handleActionsMenu(row)}
                                >
                                    <Tooltip title="Opções">
                                        <MoreHorizOutlined/>
                                    </Tooltip>
                                </IconButton>
                            </>
                        }
                    />
                </ACard>
                    <ConfirmDialog
                        title={'Delete confirmation'}
                        description={'Você tem certeza que deseja excluir esse perfil?'}
                        open={openDialog}
                        handleConfirm={confirmDialog}
                        handleClose={closeDialog}
                    />
            </Box>
                <ActionsMenu
                    open={Boolean(menuPos && selectedRow)}
                    onClose={handleCloseActionsMenu}
                    menuPos={menuPos}
                    items={getActionMenuItems()}
                />
                <UserAssociationPanel
                    open={openUserAssociationPanel}
                    onClose={() => setOpenUserAssociationPanel(false)}
                    profileId={selectedProfileForUsers?.id || 0}
                    profileName={selectedProfileForUsers?.name || ""}
                />
        </>
    );
}

export default function ProfilesSettingsPage() {
    return (
        <QueryClientProvider client={sharedQueryClient}>
            <ProfilesSettingsHomePage />
        </QueryClientProvider>
    )
}